import React, { useEffect } from "react";
import { getToken, onMessage } from "@firebase/messaging";
import { setFCMToken, setNotification } from "../store/slices/userSlice";
import { useDispatch } from "react-redux";
import { getFirebaseMessaging } from "./firebase";

function FirebaseConfig() {
  const dispatch = useDispatch();

  useEffect(() => {
    const initFirebase = async () => {
      const messaging = await getFirebaseMessaging();

      if (messaging) {
        const requestPermission = async () => {
          try {
            const permission = await Notification?.requestPermission();
            if (permission === "granted") {
              const requestForToken = () => {
                return getToken(messaging, {
                  vapidKey: process.env.REACT_APP_VAPID_KEY,
                })
                  .then((currentToken) => {
                    if (currentToken) {
                      dispatch(setFCMToken(currentToken));
                    } else {
                      // Show permission request UI
                      // console.log(
                      //   "No registration token available. Request permission to generate one."
                      // );
                    }
                  })
                  .catch((err) => {
                    // console.log(
                    //   "An error occurred while retrieving token. ",
                    //   err
                    // );
                  });
              };
              requestForToken();
            }
          } catch (error) {
            // console.log("error", error);
          }
        };

        requestPermission();

        onMessage(messaging, (payload) => {
          const notificationTitle = payload?.data?.title;
          const notificationOptions = {
            body: payload?.data?.body,
            icon: payload?.data?.icon,
          };
          dispatch(
            setNotification({
              title: notificationTitle,
              ...notificationOptions,
              isNew: true,
            })
          );
          const isAppFocused = document.hasFocus();

          if (!isAppFocused) {
            new Notification(notificationTitle, notificationOptions);
          } else {
            // Handle the message when the application is in the foreground
            // For example, update the UI or perform other actions
          }
        });
      }
    };

    initFirebase();
  }, []);

  return <></>;
}

export default FirebaseConfig;
